import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { BACKEND_SERVICE_BASE_URL } from './constants'

const httpLink = createHttpLink({
    uri: `${BACKEND_SERVICE_BASE_URL}/graphql`
});

const authLink = setContext((_, { headers }) => {
  const token = 'AAA'
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

export default client